import { createSelector } from '@ngrx/store';

import { selectDiversionsFeatureState, State } from '@ruby/modules/diversions/store';
import * as fromDiversionsHeader from '@ruby/modules/diversions/store/reducers/diversions-header.reducer';
import * as fromDiversionsPreviousRequests from '@ruby/modules/diversions/store/reducers/diversions-previous-requests.reducer';
import { selectDiversionsAuthState } from '@ruby/modules/diversions/store/selectors/diversions-core.selectors';
import { selectDiversionsHeaderFeatureState } from '@ruby/modules/diversions/store/selectors/diversions-header.selectors';

export const selectDiversionsPrevRequestsState = createSelector(
  selectDiversionsFeatureState,
  (state: State) => state[fromDiversionsPreviousRequests.featureKey]
);

export const selectDiversionsPrevRequestsFormState = createSelector(
  selectDiversionsPrevRequestsState,
  selectDiversionsHeaderFeatureState,
  selectDiversionsAuthState,
  (state: fromDiversionsPreviousRequests.State, header: fromDiversionsHeader.State, { internalRole }) => ({
    state,
    selectedCustomerDetails: header.selectedCustomerDetails,
    internalRole
  })
);
